module.exports = __webpack_public_path__ + "static/media/2 remboar pokemon tattoo anime gamer gaming color .1280x960.5212af6a.webp";